import https from './https'
import eventBus from './eventBus'
import base from './base'
import baseComp from './baseComp'
import fullscreen from 'vue-fullscreen'
import Element from 'element-ui'
import directives from './directives'
import print from 'fight-pc-print'
import detectZoom from './detect-ration'
export default {
	async install(Vue) {
		Vue.use(Element)
			.use(fullscreen)
			.use(https)
			.use(eventBus)
			.use(base)
			.use(baseComp)
			.use(directives)
			.use(print)
			.use(detectZoom)
	}
}
